import { FC, useMemo, useState } from 'react';
import Link from 'next/link';
import { Box, Typography } from '@mui/material';
import { UserDataType } from '@/modules/_core/types/user-types';
import { getPublicFileUrl } from '@/modules/_core/utils/file.utils';
import { communityCardStyles } from './community-card.styles';
import { useStyles } from '@sweatpals/react-ui-kit';
import useLink from '@/modules/_core/hooks/useLink';
import { FileVariantsEnum } from '@sweatpals/shared';

export interface CommuityCardProps {
	community?: UserDataType;
}

const CommuityCard: FC<CommuityCardProps> = ({ community }) => {
	const { id, fullName, backgroundId, interests, userName } = community ?? {};

	const { makeHostLink } = useLink();

	const backgroundUrl = useMemo(() => (backgroundId ? getPublicFileUrl(backgroundId, { variant: FileVariantsEnum.L }) : ''), [backgroundId]);

	const hostLink = useMemo(() => makeHostLink({ userName }), [userName, makeHostLink]);

	const styles = useStyles(communityCardStyles, backgroundUrl);

	return (
		<Link passHref href={hostLink} legacyBehavior>
			<Box sx={styles.root}>
				<Box sx={styles.infoSection}>
					<Typography className="underlined" sx={styles.titleText}>{fullName}</Typography>
					<Typography sx={styles.subtitleText}>emerging community</Typography>
					<Typography sx={styles.interestsText}>
						{interests?.map((interest) => interest.interest?.name).join(';')}
					</Typography>
				</Box>
			</Box>
		</Link>
	);
};

export default CommuityCard;
